export const IP_LOGIN_TOKEN_URL = '/api/v4/auth/ip-login/token/';
export const IP_LOGIN_TOKEN_STORAGE_KEY = 'IP_LOGIN_TOKEN';
